import { ArrowRight, Clock3, Headset, Music2 } from "lucide-react";
import { useNavigate } from "react-router";

import { AppLogo } from "@/utils/svg";

export default function AuthHeader() {
  const navigate = useNavigate();

  return (
    <header className="flex items-center justify-between p-6 lg:px-12 h-[100px] bg-[url('/images/signin-header-bg.png')] bg-cover bg-center">
      {/* Logo and Brand */}
      <div className="flex items-center gap-4 z-10">
        <AppLogo />
        <div className="text-white flex flex-row items-center">
          <h1 className="text-2xl lg:text-3xl font-bold tracking-tighter ">
            GURUSISH
          </h1>
          <p className="text-sm lg:text-base opacity-90 font-medium max-w-[180px] border-l-2 border-white ml-4 pl-4">
            Learning with Gamaka Box Notation
          </p>
        </div>
      </div>

      {/* Contact Info Cards + Our classes promotion */}
      <div className="hidden lg:flex items-center gap-4 z-10">
        <button
          type="button"
          onClick={() => navigate("/classes")}
          className="group flex items-center gap-2 h-[55px] pl-3 pr-5 rounded-full bg-white text-[#1F1F1F] text-[16px] font-bold shadow-md ring-1 ring-[#ff6e64]/30 transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 hover:ring-[#ff6e64]"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-[#ff6e64]/10">
            <Music2 className="w-5 h-5 text-[#ff6e64]" />
          </span>
          Our classes
          <ArrowRight className="w-5 h-5 text-[#ff6e64] transition-transform duration-200 group-hover:translate-x-1" />
        </button>

        <div className="flex items-center gap-3 bg-white backdrop-blur-sm rounded-full px-4 py-3 border border-white/10 max-h-[55px] min-w-[196px]">
          <div className="w-7.5 h-7.5 flex items-center justify-center">
            <Clock3 className="w-7.5 h-7.5 text-[#ff6e64]" />
          </div>
          <div className="text-textColor text-sm">
            <div className="font-bold text-xs">Hours</div>
            <div className="text-sm opacity-90">Mon - Fri 8 am to 9 pm</div>
          </div>
        </div>

        <div className="flex items-center gap-3 bg-white backdrop-blur-sm rounded-full px-4 py-3 border border-white/10 max-h-[55px] min-w-[196px]">
          <div className="w-7.5 h-7.5 flex items-center justify-center">
            <Headset className="w-7.5 h-7.5 text-[#ff6e64]" />
          </div>
          <div className="text-textColor text-sm">
            <div className="font-bold text-xs">Call</div>
            <div className="text-sm opacity-90">+91 98417 28747</div>
          </div>
        </div>
      </div>
    </header>
  );
}
